////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

/*global google*/

import React, { Component } from 'react';
import { Calendar } from 'react-date-range';
import { Field } from 'redux-form';
import renderField from './renderField'
import { reduxForm } from 'redux-form';


import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

let today = new Date()

const validate = values => {

    const errors = {}
    console.log(values.projectdescription)
    for (let field of ["projectdescription","operationdetails","details","duration","days"]){
        if (!values[field]){
            errors[field] = 'Required'
          }    
    }

    if (!values["mobilenetwork"] && !values["fixed"]){
        errors["networktype"] = 'Required'
    }
    if (!values["indoor"] && !values["outdoor"]){
        errors["indooroutdoor"] = 'Required'
    }

    return errors
  }

  const renderTextArea = ({ fname, placeholder, meta: { touched, error } }) => {
    return(

      <React.Fragment>
        <Field name={fname} component="textarea" placeholder={placeholder} rows="4" />
        {touched && error && <span>{error}</span>}
      </React.Fragment>
  )}

  const renderCheckboxError = ({ meta: { touched, error } }) =>
  touched && 
  error ? <span>{error}</span> : false

class ProjectOverview extends Component {
  constructor(props) {
      super(props);
    }


    state = {
        selectionRange : {
            startDate: today,
            endDate: new Date(`${today.getMonth()}/${today.getDate()}/${today.getFullYear()+3}`),
        },
        formdata: {},
        valStates: {
            "type": 0,
            "inout": 0,
            "ofcom": 0,
            "mno": 0,
            "when":0
        }
    }

  isDurationLongerThan3Years = () => {
    const startDate = this.state.selectionRange?.startDate
    const endDate = this.state.selectionRange?.endDate
    if (startDate && endDate) {
      const startPlus3Years = new Date(startDate)
      startPlus3Years.setFullYear(startDate.getFullYear() + 3)
      return startPlus3Years < endDate
    }
    return false
  }

  modifyState = (state, callback) => {
    this.setState(state, callback);
    this.props.updatePageState("ProjectOverview", state);
  }

  getFieldIfExists(field) {
      if (this.state.formdata.hasOwnProperty(field)){
          return this.state.formdata[field]["value"]
      }
      return ""
  }

  onFormFieldChange = (e) => {
        let data = this.state.formdata

        let checkboxStatus = (field) => {
            if (!data.hasOwnProperty(field)){
                return 0
            }
            if (data[field]["checked"]){
                return 2
            }
            return 1
        }

        let fieldStatus = (field) => {
            if (!data.hasOwnProperty(field)){
                return 0
            }
            if (data[field]["value"].length>0){
                return 2
            }
            return 1
        }
        let vstates = this.state.valStates
        data[e.target.name] = {
            "value": e.target.value,
            "checked": e.target.checked,
            "touched": true
        }


        vstates["type"] = checkboxStatus("Mobile Network")===2 || checkboxStatus("Fixed Wireless Network")===2 ? 2 :  checkboxStatus("Mobile Network")===1 || checkboxStatus("Fixed Wireless Network")===1 ? 1 : 0
        vstates["inout"] = checkboxStatus("indoor")===2 || checkboxStatus("outdoor")===2 ? 2 :  checkboxStatus("indoor")===1 || checkboxStatus("outdoor")===1 ? 1 : 0
        vstates["ofcom"] = fieldStatus("offcomdescription") === 2 ? 2 : fieldStatus("offcomdescription") === 1 ? 1 :0
        vstates["mno"] = fieldStatus("mnodescription") === 2 ? 2 : fieldStatus("mnodescription") === 1 ? 1 :0
        vstates["when"] = fieldStatus("when")===2 && fieldStatus("details")===2 && fieldStatus("duration")===2 && fieldStatus("days")===2 ? 2 :  fieldStatus("when")===1 || fieldStatus("details")===1 || fieldStatus("duration")===1 || fieldStatus("days")===1 ? 1 : 0

        
        this.modifyState({formdata:data, valStates:vstates})
  }


  componentWillMount() {
    
    if (this.props.getPageState("ProjectOverview")){
        let data = this.props.getPageState("ProjectOverview")
        data["selectionRange"]["endDate"] = new Date(data["selectionRange"]["endDate"])
        data["selectionRange"]["startDate"] = new Date(data["selectionRange"]["startDate"])
        this.setState(data);
        return;
    }
    this.modifyState(this.state)
  }

  render(){
    var { handleSubmit } = this.props;
    return (
      <React.Fragment>
        <h3>Step 1: Project overview <em>for Ofcom OfW588 form, Section B.1-B.4</em></h3>
        <form onSubmit={handleSubmit}>
        <h3>Select at least one network type</h3>
        <div>
            <label htmlFor={"mobilenetwork"}>Mobile Network</label>
            <div>
            <Field name={"mobilenetwork"} value={"mobilenetwork"} component="input" type="checkbox"/>
            </div>
        </div>
        <div>
            <label htmlFor={"fixed"}>Fixed Wireless Network</label>
            <div>
            <Field name={"fixed"} value={"fixed"} component="input" type="checkbox"/>
            </div>
        </div>
        <div><div>
        <Field name="networktype" component={renderCheckboxError} />
        </div></div>
        <h3>Select whether your network will operate indoor, outdoor, or both</h3>
        <div>
            <label htmlFor={"indoor"}>Indoor</label>
            <div>
            <Field name={"indoor"} id={"indoor"} component="input" type="checkbox"/>
            </div>
        </div>
        <div>
            <label htmlFor={"outdoor"}>Outdoor</label>
            <div>
            <Field name={"outdoor"} id={"outdoor"} component="input" type="checkbox"/>
            </div>
        </div>
        <div><div>
        <Field name="indooroutdoor" component={renderCheckboxError} />
        </div></div>
        <h3>Fill in all required fields below</h3>
        <div>
        <label>Project Description for Ofcom<br />Including any technical information<br/>(Ofcom OfW588 form, Section B.1a)</label>
        <div>
          <Field name="projectdescription" fname="projectdescription" placeholder="Provide a description of the request, including any relevant technical information" component={renderTextArea}/>
        </div>
        </div>
        <div>
        <label>Project Description for MNO<br />Including any technical information<br/>(Ofcom OfW588 form, Section B.1b)</label>
        <div>
          <Field name="projectdescriptionmno" fname="projectdescriptionmno" placeholder="When discussing with incumbent users, provide a description of the request if different from above" component={renderTextArea}/>
        </div>
        </div>
        <div>
        <label>Operation Details<br/>(Ofcom OfW588 form, Section B.4)</label>
        <div>
          <Field name="operationdetails" fname="operationdetails" placeholder="Provide a short description of your operational plans, e.g., continuous operation, operating on weekends, operating during summers, operating during mornings. If not continuously operating, then more context is required." component={renderTextArea}/>
        </div>
        
        </div>          
          <Field
            name={"details"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Details of timings"
            placeholder="What times of day? All day? 9 AM - 5 PM?"
          />
          <Field
            name={"duration"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Duration of transmissions"
            placeholder="Continuous or some period (e.g., 2 hours)"
          />
          <Field
            name={"days"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Days of week in operation"
            placeholder="Continuous or specify days, e.g., M,W,H,F,Su"
          />
          <h3>Select start and end date for operation of your network</h3>
        </form>
        
        <div className="row" >

            <div className="smallcal" style={{marginLeft: "auto"}}>
            <h5>On which day will you begin operation<br/> of your network?</h5>
            <Calendar
            editableDateInputs={true}
            date={this.state.selectionRange.startDate}
            onChange={(event)=>{
                this.modifyState({
                    selectionRange: {
                        startDate: event,
                        endDate: this.state.selectionRange.endDate
                    }
                })
 
            }}  
            />   
            </div>
            <div className="smallcal" style={{marginRight: "auto"}}>
            <h5>On which day will you discontinue operation<br/> of your network?</h5>
            <Calendar
            editableDateInputs={true}
            date={this.state.selectionRange.endDate}
            onChange={(event)=>{
                this.modifyState({
                    selectionRange: {
                        startDate: this.state.selectionRange.startDate,
                        endDate: event                    
                    }
                })
            }}  
            />
            
            </div>
        </div>
        { this.isDurationLongerThan3Years() && 
          <div className="row">
            <div className="col-2"></div>
            <div className="col-8">
              <div className="alert alert-warning" role="alert"><em>Warning</em>: Applications for periods longer than three years will not be accepted by Ofcom unless the application has the incumbent operator’s (MNO) support.</div>
            </div>
          </div>
        }
        <form onSubmit={handleSubmit}>
        <div className="button-row">
              <button type="button" className="btn btn-light" disabled={false} onClick={()=>{
                  /* Due to a bug this doesn't actually save, just exits. Hence the name change to Cancel. */
                  this.props.saveAndExit() 
                  }}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={false} onClick={(e)=>console.log(e)}>Next Page</button>
            </div>

        </form>
      </React.Fragment>
    );
  };

}

ProjectOverview = reduxForm({
    form: 'projectoverview', // a unique identifier for this form
    destroyOnUnmount: true, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
  })(ProjectOverview)



export default ProjectOverview



